import { useEffect } from 'react';
import { setCookie } from './CookieHelpers';

function PingRedirect() {
  useEffect(() => {
    setCookie("login_type", "SSO");
    window.location.replace("/login");
  }, []);

  return null;
}

export default PingRedirect;